module.exports = __webpack_public_path__ + "static/media/star.5b6db4e2.svg";